import { Tag } from "antd";
import { APIresponse } from "../../../model/client/response";

export const permissionDetails = (
  Permission: Array<APIresponse.Permission>
) => {
  return (
    <>
      {Permission.map((item, index) => (
        <Tag key={index} style={{ margin: 2, textAlign: "justify" }}>{item.name}</Tag>
      ))}
    </>
  );
};
